import React, { useReducer, useContext, createContext } from "react";

const initialState = {
  excelFilePath: "",
  excelFile: null,
  excelWorkBook: {},
  excelSheet: "",
  excelJson: [],
  excelHeaders: [],
  excelRows: [],
};

export const ACTIONS = {
  SET_EXCEL_FILE_PATH: "SET_EXCEL_FILE_PATH",
  SET_EXCEL_FILE: "SET_EXCEL_FILE",
  SET_EXCEL_WORKBOOK: "SET_EXCEL_WORKBOOK",
  SET_EXCEL_SHEET: "SET_EXCEL_SHEET",
  SET_EXCEL_JSON: "SET_EXCEL_JSON",
  SET_MATCH_TO_CAR: "SET_MATCH_TO_CAR",
  SET_UPLOADED_PICTURES: "SET_UPLOADED_PICTURES",
  SET_FIELD_VALUE: "SET_FIELD_VALUE",
};
const reducer = (state, action) => {
  const temp = Array.from(state.excelRows);
  console.log(action.type, action.payload);

  switch (action.type) {
    case ACTIONS.SET_EXCEL_FILE_PATH:
      return {
        ...state,
        excelFilePath: action.payload.value,
      };
    
    case ACTIONS.SET_EXCEL_FILE:
      return {
        ...state,
        excelFile: action.payload.value,
      };

    case ACTIONS.SET_EXCEL_WORKBOOK:
      return {
        ...state,
        excelWorkBook: action.payload.value,
      };

    case ACTIONS.SET_EXCEL_SHEET:
      return {
        ...state,
        excelSheet: action.payload.value,
      };

    case ACTIONS.SET_EXCEL_JSON:
      const headers = Array.from([
        ...action.payload.value[0].map((h) => {
          const newHeader = h.replace(/[\r\n]/gm, " ");
          return newHeader;
        }),
      ]);
      // const rows = Array.from(
      //   action.payload.value.map((row, index) => [
      //     ...row,
      //     <MatchToCar key={`match-to-car${index}`} index={index} />,
      //   ])
      // );
      const rows = Array.from(action.payload.value);
      rows.shift();
      return {
        ...state,
        excelJson: action.payload.value,
        excelHeaders: headers,
        excelRows: rows,
      };

    case ACTIONS.SET_FIELD_VALUE:
      const newRows = temp.map((r, index) => {
        if (index === action.payload.index) {
          const newRow = [...r];
          newRow[action.payload.field] = action.payload.value;
          return newRow;
        }
        return r;
      });
      return {
        ...state,
        excelRows: newRows,
      };

    default:
      return state;
  }
};

const ExcelFileUploadContext = createContext(initialState);

export default function ExcelFileUploadProvider({ children }) {
  return (
    <ExcelFileUploadContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </ExcelFileUploadContext.Provider>
  );
}

export const useExcelFileUploadContext = () =>
  useContext(ExcelFileUploadContext);
